module.exports = __webpack_public_path__ + "media/confetti-bang.925fa7ae.mp3";